import { Membership, SubscriptionMode, SubscriptionPackage } from '@bpm-web-app/supreme-api-sdk';
import { useGetSubscribePreview } from '@bpm-web-app/swr-hooks';
import { useUserSettings } from '@bpm-web-app/utils';
import IconTick from '../../../components/icons/tick.svg';

export const useButtonLabel = (subscriptionPackage: SubscriptionPackage, currentMembership?: Membership) => {
    const { data: planPreview, error } = useGetSubscribePreview(subscriptionPackage.id);
    const { isAnonymous } = useUserSettings();

    if (!currentMembership?.has_membership || isAnonymous) {
        return 'Get Started';
    }

    if (subscriptionPackage.is_current) {
        if (currentMembership.is_supreme_bundle) {
            return 'Manage on BPM Supreme';
        }
        return (
            <>
                <IconTick /> Current Plan
            </>
        );
    }

    if (subscriptionPackage.name === currentMembership.subscription?.package?.name && subscriptionPackage.library === currentMembership.subscription?.package?.library) {
        if (Number(subscriptionPackage.period) < Number(currentMembership.subscription?.package?.period)) {
            return 'Change to Monthly';
        }
        return 'Change to Annual';
    }

    if (planPreview?.data.mode === SubscriptionMode.Upgrade || planPreview?.data.mode === SubscriptionMode.ChangeLibUpgrade) {
        return 'Upgrade Plan';
    }

    if (planPreview?.data.mode === SubscriptionMode.Downgrade) {
        return 'Downgrade Plan';
    }

    if (error) {
        return 'Unavailable';
    }

    return 'Change Plan';
};
